<template>

<v-dialog v-model="dialog" width="1000px">
  <v-card>
    <p class=".title ma-2">Emails sent to the Hosts</p>
    <v-form ref="eignHostEmails">
     <div class="searchbox">
     <v-text-field v-model="search"  label="Search in results" single-line hide-details prepend-icon="mdi-magnify"></v-text-field>
     </div>
     <v-divider class="mt-2"></v-divider>
     <v-data-table 
       :headers="headers"
       :search="search"
       :items="eign.mail"
       :items-per-page="15"
       dense>
      <template v-slot:body="{ items }">
       <tbody>
        <tr v-for="(mail, i) in items" :key="i" @click="$router.open('/mail/showMail/' + mail.mail_encrid)">
          <td>{{mail.mail_dt}}</td>
          <td>{{mail.mail_oms}}</td>
          <td>{{mail.mail_subject}}</td>
                <td>
                  <v-chip :color="mail.mlrc_id" text-color="white">
                    <v-avatar left>
                      <v-icon v-if="mail.mlrc_id === 'success'"
                        >mdi-checkbox-marked-circle</v-icon>
                      <v-icon v-else
                        >mdi-close-circle</v-icon>    
                    </v-avatar>
                    {{ mail.mlrc_dt }}
                  </v-chip>
                </td>
        </tr>                  
       </tbody>  

      </template>  
     </v-data-table>
    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      eign_encrid: null,
      search: "",
      eign: {},
      headers: [
        { text: 'Date', value: 'mail_dt', width: '15%'},
        { text: 'Type', value: 'mail_oms', width: '20%'},
        { text: 'Subject', value: 'mail_subject', width: '45%'},
        { text: 'Result', value: 'mlrc_id', width: '30%' },
      ]
    }
  },
  methods: {
    open(eign_encrid) {
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/eign/getEignHostEmails.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getEignHostEmails"
          },
          getEignHostEmails: {
            eign_encrid: eign_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.eign = res.data.getEignHostEmails;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
}
</script>

<style scoped>
.searchbox {
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
  width: 500px;
} 
</style>